import { BookModel } from "../BookModel/BookModel";
import type { BookModelCollection } from "../BookModel/BookModelCollection";
import type { PaymentModel } from "../PaymentModel/PaymentModel";

export class BillModel extends BookModel {
  static dates: Array<string> = ["due_date"];

  billPositions() {
    return this.hasMany("billPositions");
  }

  billPayments() {
    return this.hasMany<BookModelCollection<PaymentModel>>("billPayments");
  }

  prepareBillRow() {
    return {
      id: this.id,
      billId: this.get<number>("presented.billId"),
      dueamount: this.get<string>("presented.dueAmount"),
      price: this.get<string>("presented.price"),
      downloadlink: this.get<string>("presented.downloadLink"),
      status: this.get<string>("presented.status"),
    };
  }
}
